<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div id="DynabicMenuInnerDiv">
  <div class="topheader" [class.topbutton]="isMenuDisabled">
    <div class="topsection topsection-panel">
      <button
        type="button"
        class="togglebtn"
        id="mobile-button"
        (click)="toggle()"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span> <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <div class="venturelogo">
        <a rel="nofollow" href="https://metrics.aspose.ai"> </a>
      </div>
      <div class="userlogstatus">
        <div id="DynabicMenuUserControls">
          <div class="lang-selector" id="localswitch">
            <app-language-modal />
          </div>
          <div class="userloginbox desklink" (click)="switchTheme()"></div>
        </div>
      </div>
      <div class="menuitems">
        <ul class="topheadermenus twocolmenu">
          <li>
            <a
              rel="nofollow"
              href="https://products.aspose.ai/"
              class="mobileanchor"
              >{{ "header.products" | translate }}</a
            >
            <ul>
              <div class="productmenubox">
                <a rel="nofollow" href="https://products.aspose.ai/total/"
                  ><em>Aspose.Total<b> Copilots</b></em></a
                >
                <a rel="nofollow" href="https://products.aspose.ai/words/"
                  ><em>Aspose.Words<b> Copilots</b></em></a
                >
                <a rel="nofollow" href="https://products.aspose.ai/cells/"
                  ><em>Aspose.Cells<b> Copilots</b></em></a
                >
                <a rel="nofollow" href="https://products.aspose.ai/pdf/"
                  ><em>Aspose.PDF<b> Copilots</b></em></a
                >
                <a rel="nofollow" href="https://products.aspose.ai/ocr/"
                  ><em>Aspose.OCR<b> Copilots</b></em></a
                >
                <a rel="nofollow" href="https://products.aspose.ai/font/"
                  ><em>Aspose.Font<b> Copilots</b></em></a
                >
                <a rel="nofollow" href="https://products.aspose.ai/tex/"
                  ><em>Aspose.TeX<b> Copilots</b></em></a
                >
              </div>
            </ul>
          </li>
          <li>
            <a rel="nofollow" href="#" class="mobileanchor">{{
              "header.support" | translate
            }}</a>
            <ul>
              <li>
                <a rel="nofollow" href="https://blog.aspose.ai"
                  >{{ "header.blog" | translate }}</a
                >
              </li>
            </ul>
          </li>
          <li>
            <a rel="nofollow" href="#" class="mobileanchor">{{ "header.websites" | translate }}</a>
            <ul class="websitesmenuwrapper">
              <li class="websitesmenubox">
                <a href="https://websites.aspose.com/aspose/com">aspose.com</a>
                <a href="https://websites.aspose.com/aspose/cloud"
                  >aspose.cloud</a
                >
                <a href="https://websites.aspose.com/aspose/app">aspose.app</a>
                <a href="https://websites.aspose.com/aspose/ai">aspose.ai</a>
              </li>
              <li class="websitesmenubox">
                <a href="https://websites.aspose.com/groupdocs/com"
                  >groupdocs.com</a
                >
                <a href="https://websites.aspose.com/groupdocs/cloud"
                  >groupdocs.cloud</a
                >
                <a href="https://websites.aspose.com/groupdocs/app"
                  >groupdocs.app</a
                >
                <a href="https://websites.aspose.com/groupdocs/ai"
                  >groupdocs.ai</a
                >
              </li>
              <li class="websitesmenubox">
                <a href="https://websites.aspose.com/conholdate/com"
                  >conholdate.com</a
                >
                <a href="https://websites.aspose.com/conholdate/cloud"
                  >conholdate.cloud</a
                >
                <a href="https://websites.aspose.com/conholdate/app"
                  >conholdate.app</a
                >
                <a href="https://websites.aspose.com/conholdate/ai"
                  >conholdate.ai</a
                >
              </li>
            </ul>
          </li>

          <li>
            <div id="DynabicMenuUserControlsclone"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
